import React, { useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PublicIcon from "@mui/icons-material/Public";

import { useGetSeachParam } from "../../useSearchParams";
import useActiveContexts from "../useActiveContexts";
import LeaveContextDialog from "./LeaveContextDialog";
import { useTranslation } from "react-i18next";

const initInfo = {
  name: "",
  description: "",
  accepted: 1,
  left: 0,
  firstName: "",
  lastName: "",
  email: "",
  code: "",
  community: true,
};

function ContextInfo() {
  const { t } = useTranslation();
  const { contexts } = useActiveContexts();
  const contextId = Number(useGetSeachParam("c"));
  const contextInfo =
    contexts.find((context) => context.contextId === contextId) ?? initInfo;
  const isPublic = contextInfo?.autoAccept;
  const [openDialog, setOpenDialog] = useState({
    open: false,
    type: "leave",
  });
  if (contextInfo === initInfo) return <div></div>;
  return (
    <div>
      <Card variant="outlined">
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">{contextInfo.name}</Typography>
            <Button
              startIcon={<ExitToAppIcon fontSize="small" />}
              onClick={() => setOpenDialog({ open: true, type: "leave" })}
            >
              {t("library.buttons.leave")}
            </Button>
          </Box>
          <Typography variant="body2">{contextInfo?.description}</Typography>
          <Box
            display="flex"
            alignItems="flex-start"
            sx={{ gap: 1, color: "text.secondary" }}
          >
            <SupervisorAccountOutlinedIcon />
            <Box>
              <Box display="flex" sx={{ gap: 1, color: "text.secondary" }}>
                <Typography variant="subtitle2">
                  {contextInfo.firstName} {contextInfo.lastName}
                </Typography>
                <Chip
                  color="primary"
                  size="small"
                  label={
                    <Typography variant="body2">
                      {t("library.admin")}
                    </Typography>
                  }
                />
              </Box>
              <Typography variant="body2">{contextInfo.email}</Typography>
            </Box>
          </Box>
          {isPublic ? (
            <Box
              display="flex"
              alignItems="center"
              sx={{ gap: 1, color: "text.secondary" }}
            >
              <PublicIcon fontSize="small" />
              <Tooltip title={t("library.publicGroupHelp")}>
                <Typography variant="body2">
                  {t("library.publicGroup")}
                </Typography>
              </Tooltip>
            </Box>
          ) : (
            <Box
              display="flex"
              alignItems="center"
              sx={{ gap: 1, color: "text.secondary" }}
            >
              <LockOutlinedIcon fontSize="small" />
              <Tooltip title={t("library.privateGroupHelp")}>
                <Typography variant="body2">
                  {t("library.privateGroup")}
                </Typography>
              </Tooltip>
            </Box>
          )}
        </CardContent>
      </Card>
      {openDialog.type === "leave" ? (
        <LeaveContextDialog
          open={openDialog.open}
          setOpen={setOpenDialog}
          id={contextInfo.id}
          contextName={contextInfo.name}
        />
      ) : null}
    </div>
  );
}

export default ContextInfo;
